import coblogo from "../assets/img/Assure Fire Final Logo-06.png";
import logpic from "../assets/img/Loginpic.png";
import cloud from "../assets/img/upload-cloud.png";
import { hostName } from "../config/config";
import {
  UPLOAD_CLIENT_UPLOADCLIENTBRANDING,
  CHECK_SUBDOMAIN_NAME,
} from "../api/apiPath";
import { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams, generatePath } from "react-router-dom";

import Header from "./Header";
import SidebarIcons from "./SidebarIcons";
import Sidebar from "./Sidebar";
import Toaster from "./common/Toaster";


const ClientBranding = () => {
  const { clientNameParam } = useParams();
  const [portalName, setPortalName] = useState("");
  const [logoPreview, setLogoPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(false);
  const [subdomainMessage, setSubdomainMessage] = useState(null);
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const { userObj } = useSelector((state) => state.user);
  const [logoFile, setLogoFile] = useState(null);
  const [hideSidebar, setHideSidebar] = useState(true);
    const [toastData, setToastData] = useState({
      toastShow: false,
      toastType: "",
      toastString: "",
    });
    const closeButton = () => {
      setToastData({
        toastShow: false,
        toastData: "",
        toastType: "",
      });
    };

  useEffect(() => {
    if (!userObj || !userObj?.token) {
      navigate(generatePath("/client/:clientNameParam", {
              clientNameParam,
            })
          , { replace: true, state: { from: "/ClientBranding" } });
    }
  }, [userObj, navigate]);

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogoFile(file);
      setLogoPreview(URL.createObjectURL(file));
    }
  };

  useEffect(() => {
    const checkSubdomain = async () => {
      if (!portalName.trim()) {
        setSubdomainMessage(null);
        return;
      }

      const subdomain = portalName.replace(/\s+/g, "").toLowerCase();
      setChecking(true);
      try {
        const response = await fetch(
          `${hostName}${CHECK_SUBDOMAIN_NAME}?subdomain=${subdomain}`,
          {
            headers: {
              Authorization: "Bearer " + userObj?.token,
            },
          }
        );

        const data = await response.json();
        // 🔹 Example response:
        // { available: false, suggestions: ["abc1", "abc2", "abc3"] }

        if (data?.available === false) {
          setSubdomainMessage({
            type: "error",
            suggestions: data?.suggestions || [],
          });
        } else {
          setSubdomainMessage({ type: "success" });
        }
      } catch (err) {
        console.error("Error checking subdomain:", err);
        setSubdomainMessage(null);
      } finally {
        setChecking(false);
      }
    };

    const delayDebounce = setTimeout(checkSubdomain, 600); // debounce
    return () => clearTimeout(delayDebounce);
  }, [portalName, userObj]);

  const handleContinue = async () => {
    if (!logoFile || !portalName.trim()) return;

    setLoading(true);
    try {
      const cleanSubdomain = portalName.replace(/\s+/g, "").toLowerCase();
      const fullUrl = `https://assurefireai.com/${cleanSubdomain}`;
      const formData = new FormData();
      formData.append("ClientLogo", logoFile);
      formData.append("ClientSubDomain", fullUrl);
      formData.append("ClientSubDomainName", portalName);
      formData.append("clientEmail", userObj?.userEmail);

      const response = await fetch(
        hostName + UPLOAD_CLIENT_UPLOADCLIENTBRANDING,
        {
          method: "POST",
          body: formData,
          headers: {
            Authorization: "Bearer " + userObj?.token,
          },
        }
      );

      console.log("API Response:", await response.json());
      if(response?.status === 200){
        setTimeout(() => {
          setToastData({
          toastShow: true,
          toastType: "success",
          toastString: response?.data?.message,
        });
        }, 2000);
      }
    } catch (err) {
      console.error("Error:", err);
      setTimeout(() => {
          setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: err.message || "An error occurred. Please try again.",
        });
        }, 2000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div>
        <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      </div>
      {userObj && (
        <div className="dashboard_body_main vh-100 d-flex flex-row py-0 pe-0" style={{top: "0"}}>
           <Toaster
              show={toastData.toastShow}
              toastType={toastData.toastType}
              title={toastData.toastString}
              theme={"dark"}
              position="top-center"
              closeButton={closeButton}
            />
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons />
          )}
          <div className="login-form-section d-flex flex-column justify-content-center align-items-center">
            <div className="login-form-wrapper">
              <img src={coblogo} alt="logo" className="login-logo" />
            </div>

            <div className="card-body px-5 py-3">
              <div className="col-sm-12 text-center mb-4">
                <p className="personalName">Client Onboarding</p>
              </div>

              {/* Upload Section */}
              <div className="upload-section d-flex align-items-center">
                <div className="upload-box" onClick={handleClick}>
                  <div className="upload-content">
                    {logoPreview ? (
                      <img
                        src={logoPreview}
                        alt="Uploaded Logo"
                        className="uploaded-logo"
                      />
                    ) : (
                      <img src={cloud} alt="upload" />
                    )}
                  </div>
                </div>
                <div className="upload-info ms-3">
                  <p className="upload-text">
                    Drag & drop your file here or{" "}
                    <span className="browse-link" onClick={handleClick}>
                      click to browse
                    </span>
                  </p>
                  <small className="upload-hint">PNG, JPG up to 15MB</small>
                </div>
                <input
                  type="file"
                  accept="image/png, image/jpeg"
                  style={{ display: "none" }}
                  ref={fileInputRef}
                  onChange={handleFileChange}
                />
              </div>

              {/* Portal Name */}
              <div className="mb-3 mt-3 text-start">
                <label className="form-label personalName">
                  Client Portal Name
                </label>
                <input
                  type="text"
                  className="form-controlinputbox portal-input"
                  style={{ width: "100%" }}
                  value={portalName}
                  onChange={(e) => setPortalName(e.target.value)}
                />

                {checking && (
                  <small className="text-info">Checking availability...</small>
                )}

                {!checking && subdomainMessage?.type === "success" && (
                  <small className="text-success">Subdomain available</small>
                )}

                {!checking && subdomainMessage?.type === "error" && (
                  <div>
                    <small className="text-danger d-block mb-1">
                      Subdomain already taken.
                    </small>
                    {subdomainMessage.suggestions?.length > 0 && (
                      <small
                        className="text-success"
                        style={{ color: "greenyellow" }}
                      >
                        Suggested alternatives:{" "}
                        {subdomainMessage.suggestions.join(", ")}
                      </small>
                    )}
                  </div>
                )}
              </div>

              {/* Portal URL */}
              <div className="mb-4 text-start">
                <label className="form-label personalName">
                  Client Portal URL
                </label>
                <div className="genurl">
                  <span>https://</span>
                  <span>assurefireai.com/</span>
                  <span
                    style={{ backgroundColor: "rgba(217, 217, 217, 0.10)" }}
                  >
                    {portalName.replace(/\s+/g, "").toLowerCase()}
                  </span>
                </div>
              </div>

              <div className="row">
                <div className="col-12">
                  <button
                    type="button"
                    className="btn btn-continue personalName w-100"
                    onClick={handleContinue}
                    disabled={loading || !logoFile || portalName.trim() === ""}
                  >
                    {loading ? "Please Wait..." : "Continue"}
                  </button>
                </div>
              </div>
            </div>

            <p className="footertextotp personalName mt-5">
              By continuing, you agree to our Terms of Service and Privacy
              Policy
            </p>
          </div>
          <div className="login-image-section">
            <img
              src={logpic}
              alt="login-illustration"
              className="login-side-image"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ClientBranding;
